import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Select from '../Select'
import { SelectTwoPartOption } from '../../../SelectInput'

const getVirtualizedOptionHeight = (option) => {
  const oneLineHeight = 42 // this is the calculated height an option
  const additionalLineHeight = 20
  const estimatedCharactersPerLine = 50

  const label = option && option.label
  if (!label) {
    return oneLineHeight
  }

  const visibleLabel = Array.isArray(label)
    ? label.map(part => part.toString()).join(' ')
    : label.toString()

  // virtualized rows cannot auto-size, so we approximate wrapping by text length
  const numberOfLines = Math.max(1, Math.ceil(visibleLabel.length / estimatedCharactersPerLine))
  return oneLineHeight + ((numberOfLines - 1) * additionalLineHeight)
}

const LocationSelect = (props) => {
  const {
    virtualized,
    required,
    placeholder,
    noResultsText,
    optionRenderer,
    ...otherProps
  } = props

  let selectProps = {
    placeholder,
    noResultsText,
    ...otherProps
  }

  const selectedOptionRenderer = optionRenderer || SelectTwoPartOption

  if (virtualized) {
    selectProps = {
      ...selectProps,
      virtualized,
      required,
      optionRenderer: selectedOptionRenderer,
      optionHeight: ({ option }) => getVirtualizedOptionHeight(option)
    }
  }

  return (
    <div className={classnames(
      {'vs-form-location-select--virtualized': virtualized}
    )}>
      <Select
        {...selectProps}
      />
    </div>
  )
}

LocationSelect.propTypes = {
  /**
   * A placeholder showing when no option is selected
   */
  placeholder: PropTypes.string,
  /**
   * Text to show when there are no locations on the list
   */
  noResultsText: PropTypes.string,
  /**
   * A way to display options in the list.
   * By default it uses the Select field SelectTwoPartOption renderer.
   */
  optionRenderer: PropTypes.func,
  /**
   * If the list of locations is very long, this prop will help with performance
   */
  virtualized: PropTypes.bool,
  /**
   * Classname for custom styling of this component
   */
  locationSelectClassName: PropTypes.string
}

LocationSelect.defaultProps = {
  placeholder: 'Type a location name',
  noResultsText: 'No location found'
}

export default LocationSelect

export {
  SelectTwoPartOption
}
